import indent from './image/indent.svg';
import outdent from './image/outdent.svg';
import * as EditorTypeAll from '../tinymce.d';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

export const Indent = ({ editorInstance }: Props) => {
  const changeDent = () => {
    editorInstance.execCommand('indent');
  };

  return (
    <>
      <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={changeDent}>
        <img width="18px" height="18px" src={indent} />
      </div>
    </>
  );
};

export const Outdent = ({ editorInstance }: Props) => {
  const changeDent = () => {
    editorInstance.execCommand('outdent');
  };

  return (
    <>
      <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={changeDent}>
        <img width="18px" height="18px" src={outdent} />
      </div>
    </>
  );
};
